
import { Component, Vue, Prop } from 'vue-property-decorator';
import { StatoLavorazione } from '@/models';

@Component
export default class StatoWorkflow extends Vue {
    
    @Prop({ default: StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE }) private stato!: StatoLavorazione;

    get stati() {
        return Object.values(StatoLavorazione);//.map(stato => Vue.filter('statoLavorazioneDesc')(stato));
    }
}
